import { maskName } from "@/lib/utils"
import { z } from "zod"

export const SituacaoSchema = z.enum(["REPASSADO", "NAO_IDENTIFICADO"])
export type Situacao = z.infer<typeof SituacaoSchema>

export const AlegacaoSchema = z.enum(["EM_ANALISE", "ACEITA", "RECUSADA"])
export type Alegacao = z.infer<typeof AlegacaoSchema>

export const ContratoSchema = z.object({
    id: z.string(),
    // Mascarado na borda, não no componente: assim nenhuma tela nova esquece de mascarar, e um
    // nome completo não chega ao estado da aplicação nem por engano.
    colaborador: z.string().transform(maskName),
    // Mascarado na origem. O RH tem a lista completa e reconhece pelo miolo; um link encaminhado
    // não pode virar base de dados.
    cpfMascarado: z.string(),
    contrato: z.string(),
    valor: z.number(),
    situacao: SituacaoSchema,
    alegavel: z.boolean(),
    alegacao: AlegacaoSchema.nullable(),
})
export type Contrato = z.infer<typeof ContratoSchema>

export const RepasseSchema = z.object({
    id: z.string(),
    referencia: z.string(),
    podeAlegar: z.boolean(),
    empregador: z.string(),
    cnpj: z.string(),
    competencia: z.string(),
    vencimentoGuia: z.string(),
    creditoEm: z.string().nullable(),
    esperado: z.number(),
    recebido: z.number(),
    pendente: z.number(),
    contratos: z.array(ContratoSchema),
})
export type Repasse = z.infer<typeof RepasseSchema>

export const CompetenciasSchema = z.array(z.object({ referencia: z.string(), rotulo: z.string() }))

export const UploadSchema = z.object({ upload_url: z.string(), file_path: z.string() })

// Na guia do FGTS Digital os contratos da Faz Cred saem sob o código da instituição que opera a
// operação — o RH nunca vai achar "Faz Cred" no arquivo dele.
export const INSTITUICOES = [
    { codigo: "329", nome: "QI Tech", logo: "/brand/qi-tech.png" },
    { codigo: "274", nome: "BMP", logo: "/brand/bmp.png" },
    { codigo: "457", nome: "UY3", logo: "/brand/uy3.png" },
] as const
